import React, { Dispatch, SetStateAction, useEffect } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  Callout,
  DataListItem,
  Illustration,
  InfoCard,
} from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { ApiKeyCreateResponse } from 'types/apiKeys'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import { getMaskedText } from 'utils/string'
import { Amp } from 'utils/tracker'

type ApiKeySuccessModalProps = {
  setShowSuccess: Dispatch<SetStateAction<boolean>>
  response: ApiKeyCreateResponse
}

const ApiKeySuccess = ({ setShowSuccess, response }: ApiKeySuccessModalProps) => {
  const { t } = useTranslation()
  const apiKeyAction = useAtomValue(actionAtom)

  useEffect(() => {
    Amp.track(AmplitudeEvent.EOF_INITIATE_API_KEY_SUCCESS, {
      category: AmplitudeEventCategory.MERCHANT_PORTAL,
      action: AmplitudeEventAction.CLICK,
    })
  }, [])

  return (
    <Box flexCol align="center" gapY={16} paddingT={24}>
      <Illustration name="HandsClapping" color="success" />
      <h1 className="text-h1 text-foreground-prominent">{t('manageApiKeys.apiKeyCreated')}</h1>
      {!!response && response?.access_token && (
        <InfoCard full>
          <DataListItem
            id="hawk-auth-id"
            title={t('manageApiKeys.hawkAuthId')}
            copyText={response.access_token}
            body={ellipseMiddleText(response.access_token, 18, 18, '...')}
          />
        </InfoCard>
      )}

      {!!response && response?.secret && (
        <InfoCard full>
          <DataListItem
            id="hawk-auth-id"
            title={t('manageApiKeys.secretKey')}
            copyText={response.secret}
            body={response.secret}
            maskBody={getMaskedText(20)}
          />
        </InfoCard>
      )}

      <Callout variant="warning">{t('keepSecretKeySafe')}</Callout>

      <Box flex justify="center" paddingT={8}>
        <Button
          variant="secondary"
          onClick={() => {
            setShowSuccess(false)
            apiKeyAction?.onClose?.()
          }}
        >
          {t('done')}
        </Button>
      </Box>
    </Box>
  )
}

export default ApiKeySuccess
